<template>
  <div>

    <div class="topic-header border-bottom" >
      <h2>{{ item.knowledge_check.name }}</h2>
      <p v-html="item.instructions"></p>
    </div>

    <div v-if="!question && !isFinished" class="kc-instructions">
      <span v-html="item.instructions"></span>
    </div>

    <div v-if="question" >
      <div class="d-flex p-2 question-content">
        <div class="question-label">
          {{ questionNumber }}.
        </div>
        <question v-model="answer" :question="question"></question>
      </div>
      <div class="text-center">
        <b-button v-if="questionNumber != 1" :disabled="fetching" @click.stop="previousQuestion">Previous</b-button>
        <b-button :disabled="fetching || !isAnswered()" variant="primary" @click.stop="nextQuestion">Save &amp; Next</b-button>
      </div>
    </div>

    <div v-if="isFinished && !question" class="text-center">
      <div v-if="unansweredQuestions.length > 0" class="alert alert-warning text-center">
        The following questions have not been answered. All questions must be answered.
        <ul class="pagination justify-content-center">
          <li v-for="(q) in unansweredQuestions" :key="q" class="page-item"><a class="page-link" href="#" @click.stop="pageChanged(q + 1)">{{ q + 1 }}</a></li>
        </ul>
      </div>
      <div v-if="canFinish">
        <div class="p-2">
          There are no more questions in this knowledge check. Use the finish button below to complete this knowledge check or use the question numbers below to return to
          a previous question.
        </div>
        <div class="p-3">
          <b-button :disabled="finishButtonDisabled" variant="primary" size="lg" @click.stop="finish" >Finish</b-button>
        </div>
      </div>

    </div>

    <b-row class="p-2">
      <b-col cols="12">
        <b-pagination
          v-if="questions"
          :disabled="fetching"
          :value="questionNumber"
          :total-rows="questions.length"
          :per-page="Number(1)"
          align="center"
          hide-goto-end-buttons
          @change="pageChanged">
          <template slot="last-text">
            Finish
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash'
import responseApi from '@/api/knowledgechecks/response'
import question from './question'

export default {
  components:{
    question
  },
  props:{
    item: {type: Object, required: true},
    defaultParams: {type: Object, required:true},
    isPreview: {type: Boolean, default: false},
    responseView: {type: String, required: true}
  },
  data(){
    return{
      answer: null,
      fetching: false,
      isFinished: false,
      question: null,
      questions:[]
    }
  },
  computed:{
    totalQuestions(){
      return this.questions.length
    },
    questionNumber(){
      if(!this.question){
        return this.isFinished ? this.questions.length: null
      }
      return this.questions.indexOf(this.question) + 1
    },
    knowledgecheckId(){
      return this.item.knowledge_check
    },
    responseId(){
      return this.item.id
    },
    unansweredQuestions(){
      return _.map(_.filter(this.questions, (q) => {
        const answer = this.getQuestionAnswer(q.id)
        return answer === undefined || answer.choice_ids.length < 1
      }), (x) => { return this.questions.indexOf(x)})
    },
    canFinish(){
      return ! (this.fetching || this.isPreview || (this. unansweredQuestions.length > 0))
    }
  },
  watch:{
    question(val){
      if(!val){
        this.answer = null
        return
      }

      let answer = this.getQuestionAnswer(val.id)

      if(!answer){
        answer = {
          choice_ids: [],
          question_id: val.id,
          knowledge_check_response_id: this.item.id
        }
        this.item.answers.push(answer)
      }

      this.answer = answer
    }
  },
  mounted(){
    const questionSource = this.item.knowledge_check.use_question_bank ? this.item.questions : this.item.knowledge_check.questions

    this.questions =  questionSource.sort((a, b) =>  a.order - b.order)
    this.question = this.questions[0]
  },
  methods:{
    getQuestionAnswer(questionId){
      return _.find(this.item.answers, (a) => { return a.question_id == questionId})
    },
    isAnswered(){
      return this.answer.choice_ids.length > 0
    },
    async nextQuestion(){
      this.fetching = true
      if(!this.isPreview){
        const params = _.clone(this.defaultParams)
        params.responseId = this.item.id
        params.questionId = this.question.id
        params.data = this.answer

        const response = await responseApi.answer(params)
        if(!this.answer.id){
          this.answer.id = response.data.data.id
        }
      }

      const idx = this.questions.indexOf(this.question) + 1

      if(idx != this.questions.length){
        this.question = this.questions[idx]
      }
      else{
        this.answer = null
        this.question = null
        this.isFinished = true
      }

      this.fetching = false

    },
    previousQuestion(){
      const idx = this.questions.indexOf(this.question) - 1
      this.question = this.questions[idx]
    },
    pageChanged(page){
      this.question = this.questions[page -1]
    },
    async finish(){
      if(this.isPreview){
        return
      }

      const params = _.clone(this.defaultParams)
      params.responseId = this.item.id
      params.data = this.answer

      await responseApi.complete(params)

      this.$router.push({
        name: this.responseView,
        params: _.defaults(this.defaultParams, {responseId: this.item.id})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/form.vue